export default {
  config: {
    data_table_expire_days: 366,
  },
  api: [
    { rule: "lcagent.create", allow: false },
    { rule: "lcagent.update", allow: false },
    { rule: "lcagent.delete", allow: false },
    { rule: "lcgroup.create", allow: false },
    { rule: "lcgroup.update", allow: false },
    { rule: "lcgroup.delete", allow: false },
    { rule: ".*", allow: true },
  ],
  page: [
    { rule: "getstarted/.*", allow: false },
    { rule: "dashboard/.*", allow: true },
    { rule: "settings/.*", allow: true },
    { rule: "reporting/.*", allow: true },
    { rule: "blumiraagent/.*", allow: true },
    { rule: "user/.*", allow: true },
  ],
};
